import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.708 6.667a2.708 2.708 0 1 1-5.416 0 2.708 2.708 0 0 1 5.416 0Zm-2.5 9.375H5.791c-.983 0-1.716-.867-1.215-1.713.726-1.226 2.29-2.662 5.632-2.662m3.959.625v3.75m1.875-1.875h-3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);